import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  InputBase,
  Toolbar,
  Button,
  AppBar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import React, { useState } from 'react';

import styles from './styles';

const StoreLayoutPage = () => {
  const categories = ['Cervejas', 'Copos', 'Camisetas', 'Utensílios'];
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => {
    setDrawerOpen(open);
  };

  return (
    <Box sx={styles.container}>
      {/* Header Secundário */}
      <AppBar position="static" sx={styles.secondaryHeader}>
        <Toolbar>
          {/* Botão Sanduíche para Mobile */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={styles.menuButton}
            onClick={() => toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          {/* Barra de Busca */}
          <Box sx={styles.search}>
            <InputBase placeholder="Buscar produtos…" sx={styles.searchInput} />
          </Box>
        </Toolbar>
      </AppBar>

      {/* Menu Lateral (Drawer) */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
        sx={styles.drawer}
      >
        <Box
          role="presentation"
          onClick={() => toggleDrawer(false)}
          onKeyDown={() => toggleDrawer(false)}
          sx={styles.drawerContent}
        >
          <List>
            {categories.map(category => (
              <ListItem
                key={category}
                component="button" // Componente se comportará como um botão
                // onClick={() =>
                //   console.log(`Categoria selecionada: ${category}`)
                // }
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '10px 16px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <ListItemText primary={category} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Banner */}
      <Box sx={styles.banner}>
        <Typography variant="h4" sx={styles.bannerText}>
          Promoção da Semana: Compre 6, leve 7!
        </Typography>
      </Box>

      {/* Produtos */}
      <Grid container spacing={3} sx={styles.productsContainer}>
        {Array.from({ length: 8 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card sx={styles.productCard}>
              <CardMedia
                component="img"
                height="140"
                image="https://via.placeholder.com/140"
                alt="Produto"
              />
              <CardContent>
                <Typography variant="h6">Cerveja Artesanal IPA</Typography>
                <Typography variant="body2" sx={styles.price}>
                  R$ 24,90
                </Typography>
                <Button variant="contained" sx={styles.addToCartButton}>
                  Adicionar ao Carrinho
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Footer */}
      <Box sx={styles.footer}>
        <Typography variant="body2">
          © 2025 Clube da 42. Todos os direitos reservados.
        </Typography>
        <Box
          sx={{
            mt: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">Powered by</Typography>
          <Box
            component="a"
            href="https://tribefy.com.br"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textDecoration: 'none',
              ml: 1,
              color: '#123462',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                width: 26,
                height: 26,
                borderRadius: 2,
                backgroundColor: '#1A4FA7',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 1,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: '#ffffff',
                  fontSize: '0.95rem',
                  lineHeight: 1,
                }}
              >
                T
              </Typography>
            </Box>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, fontSize: '0.95rem' }}
            >
              Tribefy
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StoreLayoutPage;
